module.exports = __webpack_public_path__ + "img/beijing.fba7cbeb.png";